export default __webpack_public_path__ + "imgs/down.c129966.svg";